import React from "react";
import UiUxSvg from "../assets/images/svg/ui-ux.svg";
import DownArrow from "../assets/images/svg/down-arrow.svg";
import VisualBranding from "../assets/images/svg/visual-branding.svg";
import WebDevelopement from "../assets/images/svg/web-development.png";
import AppDevelopement from "../assets/images/svg/app-development.png";
import GalleryImg2 from "../assets/images/gallery/gallery-img2.jpg";
import { Link } from "react-router-dom";

const Services = () => {
  return (
    <>
      {/* <!-- ====================================== Section Services ===================================== --> */}
      <section className="Services-section" id="services">
        <div className="heading-container">
          <h2 className="section-heading-text coding-skill-text fade_up">
            Capabilities.
          </h2>
          <div className="line"></div>
        </div>
        <h3 className="services-product-text fade_up">
          BUILDING DIGITAL PRODUCTS WITH BETTER EXPERIENCE
        </h3>
        <p className="visoion-text fade_up">
          My focus is on pioneering visual design solutions that set industry standards. I am dedicated to delivering excellence and ensuring client satisfaction by creating designs that are not only beautiful but also strategically effective.
        </p>
        <div className="row services-row">
          <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 services-column fade_up">
            <div className="services-img">
              <img src={UiUxSvg} alt="UI/UX Design icon" />
            </div>
            <p className="services-text">UI/UX Design</p>
            <p className="molestie">
              I create intuitive and engaging user interfaces. My UI/UX design process focuses on user satisfaction and creating seamless digital experiences.
            </p>
          </div>
          <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 services-column fade_up">
            <div className="services-img services-img2">
              <img src={VisualBranding} alt="Visual Branding icon" />
            </div>
            <p className="services-text services-text2">Visual Branding</p>
            <p className="molestie">
              I develop cohesive visual branding strategies, including logos, color palettes, and typography to build a strong brand identity and foster customer trust.
            </p>
          </div>
          <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 services-column fade_up">
            <div className="services-img services-img3">
              <img src={WebDevelopement} alt="Video Editing icon" />
            </div>
            <p className="services-text services-text3">Video Editing</p>
            <p className="molestie">
              My video editing service transforms raw footage into compelling narratives through precise cuts, professional effects, and synchronized sound design.
            </p>
          </div>
          <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 services-column fade_up">
            <div className="services-img services-img4">
              <img src={AppDevelopement} alt="Motion Graphics icon" />
            </div>
            <p className="services-text services-text4">Motion Graphics</p>
            <p className="molestie">
              I create dynamic motion graphics that animate text and visuals to explain complex ideas, enhance engagement, and elevate storytelling.
            </p>
          </div>
        </div>
      </section>
      {/* <!-- ====================================== Section Services End ===================================== --> */}
      {/* <!-- ====================================== Section Services Pop Up ===================================== --> */}
      <div id="services-popup" className="popup-container">
        <div className="popup-content popup-content2">
          <Link to="#" className="close">
            &times;
          </Link>
          <h2 className="simple-steps">UI/UX DESIGN</h2>
          <img
            className="blog-popup-img1"
            src={GalleryImg2}
            alt="UI/UX design project example"
            loading="lazy"
          />
          <p className="blog-sit-text">
            Just because we cant get out and about like we normally would,
            doesn’t mean we have to taking pictures. There’s still plenty you
            can do, provided you are prepared to use some imagination. Here are
            a few ideas to keep you shooting until normal life resumes.
          </p>
          <p className="blog-sit-text">
            Most photographers love to shoot the unusual, and you don’t get much
            more unusual than These Unprecedented Times. Right now everything
            counts as out of the ordinary. There are a number of remarkable
            things about these lockdown days that are worth photographing now we
            can remember them when it is all over.
          </p>
          <p className="blog-sit-text">
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fuga
            consequatur delectus porro sapiente molestias, magni quasi sed, enim
            corporis omnis doloremque soluta inventore dolorum consequuntur quo
            obcaecati rerum sit non.
          </p>
          <h2 className="simple-steps services-popup-text">What Is Ui/Ux?</h2>
          <p className="blog-sit-text">
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fuga
            consequatur delectus porro sapiente molestias, magni quasi sed, enim
            corporis omnis doloremque soluta inventore dolorum consequuntur quo
            obcaecati rerum sit non.
          </p>
          <p className="blog-sit-text">
            treets empty that are usually busy are remarkable and can evoke the
            sense of historical pictures from before the invention of the
            motorcar. Other things that are different at the moment will be
            queues to get into stores and the lines marked out on the floor to
            show how far apart we should be.
          </p>
        </div>
      </div>
      {/* <!-- ====================================== Services PopUp End ===================================== --> */}
    </>
  );
};
export default Services;
